import type { MediaImageSource, MediaImageVersions } from 'shared/library/media-image-versions';

type ImageBaseProps = {
  imageVersions?: MediaImageVersions | [];
  alt?: string;
  containerClassName?: string;
  imageClassName?: string;
  priority?: boolean;
  /** Web-only control for the browser's native image dragging behavior. */
  draggable?: boolean;
  /** Bitmap width limit; does not change layout sizes. */
  maxSourceWidth?: number;
  loading?: 'eager' | 'lazy';
  aspectRatio?: number;
  sizes?: string;
  onClick?: () => void;
  showLoadingPlaceholder?: boolean;
};

export type ImageProps<T = never> = ImageBaseProps & {
  src: string | MediaImageSource | null | undefined | T;
  sizeType?: ImageSizeType;
  width?: number;
};

export type ImageSizeType = 'avatar' | 'card' | 'large' | 'full';

export const nativeImageSizeTypeDimensions: Record<
  ImageSizeType,
  {
    width: number;
    aspectRatio: number;
    sizes: string;
  }
> = {
  avatar: {
    width: 128,
    aspectRatio: 1,
    sizes: '128px',
  },
  card: {
    width: 360,
    aspectRatio: 4 / 3,
    sizes: '(max-width: 360px) 100vw, 360px',
  },
  large: {
    width: 640,
    aspectRatio: 4 / 3,
    sizes: '(max-width: 1280px) 50vw, 640px',
  },
  full: {
    width: 1280,
    aspectRatio: 4 / 3,
    sizes: '(max-width: 767px) calc(100vw - 24px), (max-width: 1336px) calc(100vw - 48px), 1280px',
  },
};

export const webImageSizeTypeDimensions: Record<
  ImageSizeType,
  {
    width: number;
    aspectRatio: number;
    sizes: string;
  }
> = {
  avatar: {
    width: 128,
    aspectRatio: 1,
    sizes: '128px',
  },
  card: {
    width: 360,
    aspectRatio: 4 / 3,
    sizes: '(max-width: 360px) 100vw, 360px',
  },
  large: {
    width: 640,
    aspectRatio: 4 / 3,
    sizes: '(max-width: 767px) 100vw, (max-width: 1280px) 50vw, 640px',
  },
  full: {
    width: 1280,
    aspectRatio: 4 / 3,
    sizes: '(max-width: 767px) calc(100vw - 24px), (max-width: 1336px) calc(100vw - 48px), 1280px',
  },
};
